import Configs from "../../../api/configs";
import { toast } from "react-toastify";

export const configs = {
  state: {
    configs: [],
    schedulingConfigs: [],
  },
  reducers: {
    setConfigs(state, payload) {
      return {
        ...state,
        configs: payload,
      };
    },
    setSchedulingConfigs(state, payload) {
      return {
        ...state,
        schedulingConfigs: payload,
      }
    },
  },
  effects: (dispatch) => ({
    async loadConfigsAsync() {
      const configs = localStorage.getItem('configs');
      if (configs) {
        this.setConfigs(JSON.parse(configs));
        return;
      }
      const { data } = await Configs.getAlloweds();
      this.setConfigs(data);
      localStorage.setItem('configs', JSON.stringify(data));
    },
    async updateAutoImportEnabled(payload) {
      await Configs.updateAutoImportEnabled(payload);
      return true;
    },
    async isAutoImportEnabled() {
      const { data } = await Configs.isAutoImportEnabled();
      return data;
    },
    async getSchedulingConfigs() {
      const plainSchedulingConfigs = localStorage.getItem('schedulingConfigs');

      if (plainSchedulingConfigs) {
        const scheduleConfig = JSON.parse(plainSchedulingConfigs);
        this.setSchedulingConfigs(scheduleConfig);
        return;
      }

      try {
        const { data } = await Configs.getSchedulingConfigs();
        localStorage.setItem('schedulingConfigs', JSON.stringify(data));
        this.setSchedulingConfigs(data);
        return;
      } catch (error) {
        toast.error('Erro ao carregar configurações de preferências de grid');
        return;
      }

    },
    async updateSchedulingConfigColumnVisibility(payload, rootState) {
      const { schedulingConfigs } = rootState.configs;
      const { currentTab, columns } = payload;
      const newSchedulingConfigs = schedulingConfigs.map((item, index) => {
        if (index === currentTab) {
          item.columns = columns;
        }
        return item;
      });

      try {
        await Configs.saveJson({key: 'page_schedulings', configs: newSchedulingConfigs});
      } catch (error) {
        toast.error('Erro ao salvar configurações de preferências de grid');
      }

      localStorage.setItem('schedulingConfigs', JSON.stringify(newSchedulingConfigs));
      this.setSchedulingConfigs(newSchedulingConfigs);
    },
  }),
};
